import type { ReactNode } from 'react';
import { WidgetIcon, type WidgetIconName, type WidgetTone } from './WidgetIcon.js';

/**
 * The card chrome every dashboard section shares: an icon badge, a title, an
 * optional link to the full screen, and a body. Nothing here knows about leases
 * or charges — it wraps whatever the caller already renders (`BalanceTable`,
 * a paragraph, a list), so a role dashboard changes what goes in a widget, never
 * what a widget is.
 */
export function Widget({
  icon,
  tone,
  title,
  action,
  children,
}: {
  icon: WidgetIconName;
  tone: WidgetTone;
  title: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="widget">
      <header className="widget__header">
        <WidgetIcon name={icon} tone={tone} />
        <h2 className="widget__title">{title}</h2>
        {action ? <span className="widget__action">{action}</span> : null}
      </header>
      <div className="widget__body">{children}</div>
    </section>
  );
}
